import React from 'react';
import './CourseModal.css';
import { getThumbnailUrl, extractVideoId } from '../utils/youtubeUtils';

const CourseModal = ({ course, onClose }) => {
  const handlePlaylistClick = () => {
    window.open(course.playlistUrl, '_blank', 'noopener,noreferrer');
  };

  const handleLectureClick = (videoUrl) => {
    window.open(videoUrl, '_blank', 'noopener,noreferrer');
  };

  // Process lectures - convert URLs to lecture objects
  const processedLectures = (course.lectures || []).map((lecture, index) => {
    // If lecture is already an object, use it
    if (typeof lecture === 'object' && lecture.videoUrl) {
      return {
        ...lecture,
        title: lecture.title || `Lecture ${index + 1}`, // Default title if not provided
        thumbnail: lecture.thumbnail || getThumbnailUrl(lecture.videoUrl),
        position: lecture.position || index + 1,
      };
    }
    
    // If lecture is just a URL string, convert it
    const videoUrl = typeof lecture === 'string' ? lecture : lecture.videoUrl;
    const videoId = extractVideoId(videoUrl);
    
    return {
      id: videoId,
      title: `Lecture ${index + 1}`, // Default naming: "Lecture 1", "Lecture 2", etc.
      description: typeof lecture === 'object' ? lecture.description || '' : '',
      thumbnail: getThumbnailUrl(videoUrl),
      position: index + 1,
      videoUrl: videoUrl,
    };
  });

  // Get course thumbnail - prioritize custom thumbnail (playlist thumbnail), then use first lecture as fallback
  const courseThumbnail = course.thumbnail || processedLectures[0]?.thumbnail || null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>

        <div className="modal-header">
          <div className="modal-thumbnail">
            {courseThumbnail ? (
              <img src={courseThumbnail} alt={course.title} />
            ) : (
              <div className="modal-thumbnail-placeholder">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
                </svg>
              </div>
            )}
            <button className="play-playlist-btn" onClick={handlePlaylistClick}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
              <span>Play All</span>
            </button>
          </div>
          <div className="modal-header-info">
            <h2 className="modal-title">{course.title}</h2>
            <p className="modal-description">{course.description}</p>
            <div className="modal-stats">
              <span>{processedLectures.length} Lectures</span>
            </div>
          </div>
        </div>

        <div className="modal-lectures">
          <h3 className="lectures-title">Lectures</h3>
          {processedLectures.length > 0 ? (
            <div className="lectures-list">
              {processedLectures.map((lecture, index) => (
                <div
                  key={lecture.id || index}
                  className="lecture-item"
                  onClick={() => handleLectureClick(lecture.videoUrl)}
                >
                  <div className="lecture-number">{lecture.position}</div>
                  <div className="lecture-thumbnail">
                    {lecture.thumbnail ? (
                      <img src={lecture.thumbnail} alt={lecture.title} />
                    ) : (
                      <div className="lecture-thumbnail-placeholder">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    )}
                    <div className="lecture-play-overlay">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                  <div className="lecture-info">
                    <h4 className="lecture-title">{lecture.title}</h4>
                    {lecture.description && (
                      <p className="lecture-description">{lecture.description.substring(0, 100)}...</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="lectures-empty">
              <p>No lectures added yet.</p>
              <p className="lectures-fallback">
                <a href={course.playlistUrl} target="_blank" rel="noopener noreferrer">
                  View Playlist on YouTube
                </a>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseModal;
